import React, {
  useRef,
  useState,
  ReactElement,
  ReactNode,
  CSSProperties,
} from 'react';
import '@/style/components/tooltip/customTooltip.less';

const CustomTooltip = ({
  content,
  children,
  style,
}: {
  content: string | ReactElement | undefined;
  children: ReactNode;
  style: CSSProperties;
}) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleMouseEnter = () => {
    setVisible(true);
  };

  const handleMouseLeave = () => {
    setVisible(false);
  };

  return (
    <>
      <div
        ref={ref}
        className="tooltip-trigger"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          marginLeft: '8px',
        }}
      >
        {children}
      </div>
      {visible && (
        <div id="custom-tooltip" className="custom-tooltip" style={style}>
          {content}
        </div>
      )}
    </>
  );
};

export default CustomTooltip;
